const observer = new MutationObserver((mutations, obs) => {
  const shadowHost = document.getElementById('pushowl-bis-shadow-host');

  if (shadowHost) {
    const root = shadowHost.shadowRoot || shadowHost;
    const form = root.querySelector('form');

    if (form) {
      form.addEventListener('submit', async (e) => {
        const productName = document.querySelector('.product-single__title')?.textContent?.trim();
        const skuElement = document.querySelector('[data-sku]');
        const productSku = skuElement ? skuElement.textContent.trim() : 'SKU_NOT_FOUND';

        const payload = {
          product_name: productName,
          sku: productSku,
          event_type: "back_in_stock_submission"
        };

        try {
          await fetch('https://hooks.zapier.com/hooks/catch/16701482/upl1fvz/', {
            method: 'POST',
            mode: 'no-cors',
            headers: { 'Content-Type': 'text/plain' },
            body: JSON.stringify(payload)
          });
        } catch (error) {
          console.error('Webhook Error:', error);
        }
      });
      obs.disconnect();
    }
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});